import React from "react";
import { useApp } from "@/context/AppContext";

export const AffinityRing = ({ value = 0, size = 120, strokeWidth = 10 }) => {
  const { t } = useApp();
  const radius = (size - strokeWidth) / 2;
  const c = 2 * Math.PI * radius;
  const pct = Math.min(100, Math.max(0, value)) / 100;
  const offset = c - pct * c;
  const color = pct > 0.7 ? "#2D5A4C" : pct > 0.4 ? "#D97757" : "#F2C46D";

  return (
    <div className="relative inline-flex" style={{ width: size, height: size }} data-testid="affinity-ring">
      <svg width={size} height={size}>
        <circle cx={size / 2} cy={size / 2} r={radius} strokeWidth={strokeWidth} stroke="#EEE7DA" fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          strokeWidth={strokeWidth} stroke={color} fill="none"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 700ms ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 grid place-items-center">
        <div className="text-center leading-none">
          <div className="font-bold" style={{ fontFamily: "Outfit", color, fontSize: Math.min(20, Math.max(12, Math.round(size * 0.3))), lineHeight: 1 }}>{Math.round(value)}%</div>
          {size >= 100 && <div className="text-[10px] uppercase tracking-wider mt-0.5" style={{ color: "var(--yalola-text-muted)" }}>{t("affinity.label", "affinité")}</div>}
        </div>
      </div>
    </div>
  );
};
